import { useRoute } from 'vue-router'
function normalizedTeamPid(teamPid: string | string[] | undefined) {
  return Array.isArray(teamPid) ? teamPid[0] : teamPid
}

function normalizedBillingReturnPath(returnPath: string) {
  return returnPath.startsWith('/') && !returnPath.startsWith('//') ? returnPath : '/'
}

export function buildBillingActionUrl(
  teamPid: string | string[] | undefined,
  action: 'billing' | 'subscribe' | 'changePlan',
  returnPath: string,
  params: Record<string, string> = {}
) {
  const query = new globalThis.URLSearchParams(params)
  query.set('redirect', normalizedBillingReturnPath(returnPath))
  const actionPath = action === 'billing' ? 'portal' : action
  const encodedTeamPid = encodeURIComponent(String(normalizedTeamPid(teamPid) ?? ''))

  // Stay on the dashboard origin. A full navigation to the API host hits the
  // named login route, which used to bounce through /oauth/continue.
  return `/api/${encodedTeamPid}/billing/${actionPath}?${query.toString()}`
}

export function buildBillingPortalUrl(teamPid: string | string[] | undefined, returnPath: string) {
  return buildBillingActionUrl(teamPid, 'billing', returnPath)
}

export function useBillingUrl() {
  const route = useRoute()

  const goToBillingPortal = () => {
    const teamPid = route.params.teamPid
    window.location.href = buildBillingPortalUrl(teamPid, route.fullPath)
  }

  return { goToBillingPortal }
}
